import { render } from "./AddOrderModal.vue?vue&type=template&id=663fbb4d"
import script from "./AddOrderModal.vue?vue&type=script&lang=js"
export * from "./AddOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__